import React from 'react';
import { useTranslation } from 'react-i18next';

const PercheUnAccompagnatore = () => {
  const { t } = useTranslation();

  return (
    <div className="page-hero-layout perche-page" style={{
      backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)), url('https://images.unsplash.com/photo-1775489876582-eb1001a68f16')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <div className="top-bar" />
      <div className="hero-overlay-content">
        <div className="text-overlay-box perche-content professional-white extended-box">
          <h1 className="page-title-hero-inside">{t('perche.title')}</h1>
          <p>{t('perche.p1')}</p>

          <p>
            {t('perche.p2Part1')} <strong>{t('perche.p2Bold')}</strong>{t('perche.p2Part2')}
          </p>

          <p className="emphasis-text">{t('perche.emphasis')}</p>

          <p>{t('perche.p3')}</p>
          <p>{t('perche.p4')}</p>

          <h3 className="section-subtitle-perche">{t('perche.subtitle')}</h3>

          <p className="final-question">
            {t('perche.finalPart1')} <strong>{t('perche.finalBold')}</strong>
          </p>

          <p className="signature">{t('perche.signature')}</p>
        </div>
      </div>
    </div>
  );
};

export default PercheUnAccompagnatore;
